module.exports = __webpack_public_path__ + "static/img/tree@3x.fe1551c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/tree@3x.png
// module id = vBqa
// module chunks = 0